import { useState, useMemo, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { AnimatePresence, motion } from 'motion/react';
import { useNavigation } from '../../utils/NavigationContext';
import AssetCarousel from '../../components/AssetComponents/AssetCarousel';
import FileDisplayPDF from '../../components/FileDisplayPDF';
import LoadingSpinner from '../../components/LoadingSpinner';
import { handlePdf, handleFileType } from '../../utils/hooks/useAssetQR';
import API from '../../API';
import styles from './ScheduleDisplay.module.css';

const ScheduleDisplay = () => {
    const { setShowNavigation } = useNavigation();
    const params = useParams();
    const navigate = useNavigate();
    const { getQR } = API;

    const { id, scheduleId } = useMemo(() => params || {}, [params]);
    const [qr, setQr] = useState({
        id: '',
        data: {},
    });
    const schedule = useMemo(() => (qr?.id && qr?.data?.schedule?.[scheduleId]) || {}, [scheduleId, qr, qr?.data, qr?.data?.schedule?.[scheduleId]]);
    const [assets, setAssets] = useState([]);

    useEffect(() => {
        let isMounted = true;
        

        const handleAssets = async (files) => {
            try {
                const arr = [];
                for (const file of files) {
                    const fileType = handleFileType(file.path);
                    const url = fileType === 'pdf' ? await handlePdf(file.url) : file.url;
                    const assetObj = {
                        path: file.path,
                        url,
                        fileType
                    };

                    arr.push(assetObj);
                };
                return arr;
            } catch (err) {
                console.error('Error retrieving assets: ', err.message);
            };
        };

        const handleGetQR = async () => {
            try {
                const qr = await getQR(id);

                if (qr) isMounted && setQr({ id: id, data: qr });
                if (qr.schedule?.[scheduleId]?.resources?.type === 'pdf') {
                    setShowNavigation(false);
                }
                if (qr.schedule?.[scheduleId]?.resources?.type === 'asset') {
                    const assetsResponse = await handleAssets(qr.schedule?.[scheduleId]?.resources?.data);
                    setAssets(assetsResponse);
                };
            } catch (err) {
                console.error('Error gettings QR for file display: ', err?.message || '');
            };
        };

        if (!id || !scheduleId) {
            navigate('/notfound');
        };

        if (!qr.id) {
            handleGetQR();
        };

        return () => {
            isMounted = false;
            setQr(null);
            setShowNavigation(true);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    if (schedule && schedule?.resources?.type === 'pdf') {
        return <FileDisplayPDF fileToServe={schedule.resources.data[0].url} />
    };

    if (schedule && schedule?.resources?.type === 'asset') {
        return (
            <div className={styles.wrapper}>
                <div className={styles.container}>
                    <div className={styles.display}>
                        <AnimatePresence mode='wait'>
                            <motion.div
                                key='asset-carousel'
                                initial={{ opacity: 0 }}
                                animate={{ opacity: 1 }}
                                exit={{ opacity: 0 }}
                                transition={{ duration: 0.3 }}
                                className={styles.fadeContainer}
                            >
                                <AssetCarousel assets={assets} qr={qr} />
                            </motion.div>
                        </AnimatePresence>
                        <div className={styles.displayName}>Liquid Label</div>
                    </div>
                </div>
            </div>
        );
    };

    return <LoadingSpinner />;
};

export default ScheduleDisplay;
